import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceXLarge,
  spaceMin,
}: Theme) => ({
  root: {
    padding: `${spaceXLarge} 0`,
  },
  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  search: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '36.25rem',
  },
  searchLabel: {
    display: 'block',
    marginBottom: '0.25rem',
    color: palette.primary.dark,
    letterSpacing: -0.32,
  },
  input: {
    display: 'block',
    width: '100%',
    height: '100%',
    padding: '0.75rem 4.5rem 0.75rem 1.5rem',
    border: `1px solid ${palette.primary.dark}`,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  searchLabelSmall: {
    color: palette.primary.dark,
    letterSpacing: -0.32,
  },
  logosWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: spaceMin,
    padding: 0,
    margin: 0,
  },
  listItem: {
    display: 'flex',
    flexBasis: '12.08125rem',
    height: '6.25rem',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem',
    margin: 0,
    background: palette.grey['200'],
    '& img': {
      maxWidth: '100%',
      objectFit: 'contain',
    },
  },
  ctaWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
